import React, { useState } from "react";
import { CicdFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const CloudServices = () => {
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Ayanshtech Solutions — a trusted Cloud Services Provider offering secure cloud computing engineering, scalable infrastructure, and reliable cloud solutions for your business."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Cloud Services Provider | Secure Cloud Computing Engineering | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="http://ayanshtechnology.com/cloud-services"
        />
        <meta
          property="og:description"
          content="Ayanshtech Solutions — a trusted Cloud Services Provider offering secure cloud computing engineering, scalable infrastructure, and reliable cloud solutions for your business."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="http://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Cloud Services Provider | Secure Cloud Computing Engineering | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Ayanshtech Solutions — a trusted Cloud Services Provider offering secure cloud computing engineering, scalable infrastructure, and reliable cloud solutions for your business."
        />
        <meta
          name="twitter:image"
          content="http://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="http://ayanshtechnology.com/cloud-services"
        />
        <title>
          Cloud Services Provider | Secure Cloud Computing Engineering |
          Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center mb-6 p-6">
        <div className=" py-5 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16 ">
            <div className="lg:w-3/4 lg:text-left p-4">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Secure Cloud Computing Engineering Services
              </h1>

              <p className="sm:text-base md:text-lg lg:text-lg mb-3">
                In today’s digital era, secure cloud computing engineering
                services have become the foundation of scalable, efficient, and
                future-ready business operations. By leveraging the power of the
                cloud, businesses can reduce infrastructure costs, strengthen
                data security, and achieve seamless scalability and performance.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                At Ayanshtech, we specialize in delivering end-to-end cloud
                engineering solutions that are secure, reliable, and customized
                to your business needs. Our experts help you harness the full
                potential of cloud computing while ensuring your data and
                applications remain protected from modern cyber threats.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Our cloud engineering expertise covers leading platforms like
                AWS, Microsoft Azure, and Google Cloud Platform (GCP). We
                design, migrate, deploy, and optimize secure cloud architectures
                that enhance business agility and performance. Whether you’re
                building cloud-native applications, modernizing legacy systems,
                or implementing hybrid cloud solutions, our team ensures a
                smooth, secure, and efficient transition. .
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                From infrastructure setup to DevOps automation and disaster
                recovery planning, our cloud services are built with security
                and scalability at their core. With Ayanshtech’s Secure Cloud
                Computing Engineering Services, you can streamline operations,
                optimize costs, and accelerate innovation—while maintaining
                complete trust and compliance in your cloud ecosystem.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0">
              <img
                src="\assets\images\devops\cloudImg1.avif"
                alt="Cloud Services Provider"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="mb-5 mt-10 p-4 ">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our Cloud Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Cloud services empower businesses with flexibility, scalability, and
            security to meet modern-day demands. Our cloud solutions are
            designed to optimize operations, enhance data management, and drive
            innovation. Explore the key features that make our cloud services
            stand out.
          </p>
        </div>

        <div className=" p-4 ml-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cloud Migration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cloud-Native Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Scalable Infrastructure</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Disaster Recovery</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Multi-Cloud Support</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Security and Compliance</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cost Optimization</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">AI/ML Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Managed Services</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Hybrid Cloud Solutions</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Data Analytics and Insights</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Containerization with Docker & Kubernetes
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Cloud-Based CI/CD Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Transform your software delivery process with cutting-edge
            cloud-powered CI/CD solutions, enabling scalability, agility, and
            seamless integration across your cloud infrastructure.
          </p>
        </div>

        <div className="">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\devops\cloudImg2.jpg"
                alt="Cloud Services for CI/CD"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="AWS Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Seamlessly integrate CI/CD pipelines with AWS cloud
                    services, including CodePipeline, Lambda, and S3, for a
                    fully automated cloud-native workflow.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="Azure Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Leverage Azure DevOps for CI/CD pipelines, enabling
                    efficient build, test, and deployment processes across Azure
                    cloud environments.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon15.png"
                  alt="GCP Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Utilize Google Cloud services like Cloud Build and Artifact
                    Registry to implement scalable CI/CD workflows optimized for
                    GCP.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon16.png"
                  alt="Docker Icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Deploy containerized applications with ease using Docker and
                    Kubernetes integrations, ensuring consistent deployments
                    across cloud platforms.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-3xl">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Cloud-Based CI/CD Solutions We Deliver
            </h2>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">AWS CodePipeline</h3>
                <p className="text-lg">
                  Utilize AWS CodePipeline to automate your build, test, and
                  deployment workflows on the cloud for faster and reliable
                  software delivery.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Google Cloud Build</h3>
                <p className="text-lg">
                  Leverage Google Cloud Build to develop and deploy scalable
                  applications seamlessly with automated CI/CD pipelines.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Azure DevOps</h3>
                <p className="text-lg">
                  Implement Azure DevOps to create cloud-powered CI/CD
                  pipelines, ensuring smoother collaboration and enhanced
                  project workflows.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">GitHub Actions</h3>
                <p className="text-lg">
                  Automate your workflows with GitHub Actions, offering flexible
                  CI/CD capabilities and direct integration with GitHub
                  repositories.
                </p>
              </div>

              {/* Item 5 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Docker Cloud CI/CD</h3>
                <p className="text-lg">
                  Use Docker’s cloud-based CI/CD tools for containerized
                  applications, ensuring consistency across development,
                  staging, and production environments.
                </p>
              </div>

              {/* Item 6 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">CircleCI</h3>
                <p className="text-lg">
                  Streamline your software delivery with CircleCI’s cloud-based
                  pipelines, designed to support complex workflows with ease.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 sm:p-8 md:p-12 lg:p-16 w-full rounded-3xl">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Expert Cloud CI/CD Consulting and Support Solutions
            </h2>
          </div>

          <div className="mb-8">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              At Ayanshtech, we specialize in providing cloud-first CI/CD
              solutions to empower businesses with scalable, efficient, and
              reliable deployment workflows.
            </p>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Our key offerings include:
            </p>
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>Cloud-native CI/CD pipeline design and implementation</li>
              <li>
                Integration with leading cloud platforms like AWS, Azure, and
                GCP
              </li>
              <li>Automated testing and deployment workflows</li>
              <li>
                Containerization and orchestration using Docker and Kubernetes
              </li>
              <li>Comprehensive monitoring and reporting solutions</li>
            </ul>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Let our cloud CI/CD experts guide your development journey with
              tailored strategies and cutting-edge tools.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:border hover:border-blue-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free Consultation Today!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6 py-20 w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {CicdFaqs.map((faq, index) => (
            <div key={index} className="border-b ">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default CloudServices;
